import React from 'react';

import { Card, CardContent } from 'e100-react-components';

import { useStyles } from './styles';

export const FlatCard = ({ children }: FlatCardProps) => {
  const classes = useStyles();

  return (
    <Card raised={false} classes={{ root: classes.container }}>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
};

interface FlatCardProps {
  children: React.ReactNode;
}
